import './styles.scss';

import rejectedIcon from '../../../../images/loan-rejected.svg';

import React, {PropsWithChildren} from 'react';

import {ContactUs} from '../../ContactUs/ContactUs';

interface ErrorViewProps extends PropsWithChildren {
    title: string;
    icon?: string;
}

export const ErrorView = ({title, children, icon = rejectedIcon}: ErrorViewProps) => {
    return (
        <div className='error-view'>
            <div className='error-view__details'>
                <div className='error-view__image'>
                    <img src={icon} alt={title} />
                </div>
                <div className='error-view__content'>
                    <h3 className='error-view__title'>{title}</h3>
                    {children}
                </div>
            </div>
            <ContactUs>
                <p>For any further questions,</p>
                <p>please don't hesitate to contact us</p>
            </ContactUs>
        </div>
    );
};
